var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrandaWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "119.38mm",
    height: "151.77mm",
    viewBox: "0 0 338.4 430.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_blue-2"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.1,325H8.4c-1.4,0-2.5-1.1-2.5-2.5v-138.3c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v135.8h142.1c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.4,2.5h0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4,152.9c-1.4,0-2.5-1.1-2.5-2.5V8.3c0-1.4,1.1-2.5,2.5-2.5h145.2c1.4,0,2.5,1.1,2.5,2.5s-1.1,2.5-2.5,2.5H10.9v139.7c0,1.3-1.1,2.4-2.5,2.4Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.6,152.9c-1.4,0-2.5-1.1-2.5-2.5V10.7h-142.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h145.1c1.4,0,2.5,1.1,2.5,2.5v142.1c0,1.5-1.1,2.6-2.4,2.6h0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.6,325h-145.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5h143.2v-135.8c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v138.3c0,1.4-1.2,2.5-2.5,2.5h0Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.65
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.8,84.1l-24.5-24.5c-.5-.5-1.1-.7-1.8-.7h-40.1c-1.4,0-2.5,1.1-2.5,2.5v77.5c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5V63.9h36.6l23.1,23.1v156.9l-23.1,23.1h-36.6v-74.9c0-1.4-1.1-2.5-2.5-2.5s-2.5,1.1-2.5,2.5v77.4c0,1.4,1.1,2.5,2.5,2.5h40.1c.7,0,1.3-.3,1.8-.7l24.5-24.5c.5-.5.7-1.1.7-1.8V85.8c.1-.7-.2-1.3-.7-1.7Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.6,189.9h-16c-1.4,0-2.5,1.1-2.5,2.5v55.3c0,1.4,1.1,2.5,2.5,2.5h8.6c.7,0,1.3-.3,1.8-.7l20.3-20.3c.5-.5.7-1.1.7-1.8v-124c0-.7-.3-1.3-.7-1.8l-20.3-20.3c-.5-.5-1.1-.7-1.8-.7h-8.6c-1.4,0-2.5,1.1-2.5,2.5v53.6c0,1.4,1.1,2.5,2.5,2.5h26.4v50.7h-10.4ZM238.2,245.2h-5.1v-50.4h23.9v31.6l-18.8,18.8h0ZM246.5,134.2h-13.4v-48.6h5.1l18.8,18.8v29.9l-10.5-.1h0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5,59.1h-40.1c-.7,0-1.3.3-1.8.7l-24.5,24.6c-.5.5-.7,1.1-.7,1.8v158.8c0,.7.3,1.3.7,1.8l24.5,24.5c.5.5,1.1.7,1.8.7h40.1c1.4,0,2.5-1.1,2.5-2.5v-77.5c0-1.4-1.1-2.5-2.5-2.5s-2.5,1.1-2.5,2.5v75h-36.6l-23.1-23V87.1l23.1-23.1h36.6v75c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5V61.6c0-1.4-1.1-2.5-2.5-2.5h0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3,140.9h16c1.4,0,2.5-1.1,2.5-2.5v-55.3c0-1.4-1.1-2.5-2.5-2.5h-8.6c-.7,0-1.3.3-1.8.7l-20.3,20.3c-.5.5-.7,1.1-.7,1.8v124.1c0,.7.3,1.3.7,1.8l20.3,20.3c.5.5,1.1.7,1.8.7h8.6c1.4,0,2.5-1.1,2.5-2.5v-53.6c0-1.4-1.1-2.5-2.5-2.5h-26.3v-50.7h10.3v-.1ZM102.8,85.6h5.1v50.4h-23.9v-31.6l18.8-18.8ZM94.5,196.6h13.3v48.7h-5.1l-18.7-18.9v-29.9l10.5.1h0Z",
    fill: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.5,296.3h-79.9c-2.7,0-5-2.2-5-5v-97.2c0-2.7,2.2-5,5-5s5,2.2,5,5v92.2h72.9l28.1-28.1V72.6l-28.1-28.1h-72.9v114.1h49.9c2.7,0,5,2.2,5,5s-2.2,5-5,5h-54.8c-2.7,0-5-2.2-5-5V39.5c0-2.7,2.2-5,5-5h79.9c1.3,0,2.6.5,3.5,1.5l31,31c.9.9,1.5,2.2,1.5,3.5v189.8c0,1.3-.5,2.6-1.5,3.5l-31,31c-1,.9-2.3,1.4-3.6,1.5h0Z",
    fill: "#fff",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.3,296.3h-79.9c-1.3,0-2.6-.5-3.5-1.5l-31-31c-.9-.9-1.5-2.2-1.5-3.5V70.5c0-1.3.5-2.6,1.5-3.5l31-31c.9-.9,2.2-1.5,3.5-1.5h79.8c2.7,0,5,2.2,5,5v97.2c0,2.7-2.2,5-5,5s-5-2.2-5-5V44.5h-72.7l-28.1,28.1v185.7l28.1,28.1h72.8v-114.2h-49.9c-2.7,0-5-2.2-5-5s2.2-5,5-5h54.8c2.7,0,5,2.2,5,5v124.1c0,2.7-2.2,5-4.9,5h0Z",
    fill: "#fff",
    strokeWidth: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3,410.1l-2.5-15.4h-12.3l-2.2,15.4H2.5l9.4-60.5h10.6l10.5,60.5h-6.7ZM12.2,389h10.6l-5.6-34.7s-4.9,34.7-5,34.7Z",
    fill: "#fff",
    isolation: "isolate",
    opacity: 0.65,
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9,404.3h13.9v5.7h-20.5v-60.5h6.6s0,54.8,0,54.8Z",
    fill: "#fff",
    isolation: "isolate",
    opacity: 0.65,
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8,404.3h16.6v5.7h-23.3v-60.5h22.7v5.7h-16v20.4h13v5.7h-13v23Z",
    fill: "#fff",
    isolation: "isolate",
    opacity: 0.65,
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M139.8,367h-8.9v-8.1c0-1.2-.2-1.9-.6-2.3-.4-.4-1.2-.5-2.3-.5h-5c-1.2,0-1.9.2-2.3.5-.4.4-.6,1.1-.6,2.3v41.5c0,1.2.2,1.9.6,2.3s1.2.5,2.3.5h5c1.2,0,1.9-.2,2.3-.5.4-.4.6-1.1.6-2.3v-14.9h-4.9v-6.8h13.7v22.8c0,5.8-3,8.6-9,8.6h-10.4c-6,0-9-2.9-9-8.6v-43.8c0-5.7,3-8.6,9-8.6h10.4c6,0,9,2.9,9,8.6v9.3h.1Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M158.2,385.5v24.6h-8.8v-60.9h19.9c6,0,9,2.9,9,8.6v19.1c0,4.9-2.2,7.8-6.5,8.5l9.6,24.8h-9.4l-9.1-24.6-4.7-.1h0ZM158.2,356.3v22.2h8.6c1.2,0,1.9-.2,2.3-.5.4-.4.6-1.1.6-2.3v-16.5c0-1.2-.2-1.9-.6-2.3-.4-.4-1.2-.5-2.3-.5h-8.6v-.1Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M210.8,410.1l-2.4-14.1h-12.8l-2.2,14.1h-8.8l10.8-60.9h12.6l11.6,60.9h-8.8ZM196.6,388.9h10.6l-5.5-32.1-5.1,32.1h0Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M248,349.2h8.1v60.9h-8.9l-12.8-44v44h-8.1v-60.9h9.2l12.4,42.7.1-42.7h0Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M266.9,349.2h21.2c6,0,9,2.9,9,8.6v43.8c0,5.7-3,8.6-9,8.6h-21.2v-61ZM288.3,400.4v-41.4c0-1.2-.2-1.9-.6-2.3s-1.2-.5-2.3-.5h-9.6v47.1h9.6c1.2,0,2-.2,2.3-.5.4-.5.6-1.3.6-2.4h0Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M329.6,410.1l-2.4-14.1h-12.8l-2.2,14.1h-8.8l10.8-60.9h12.7l11.6,60.9h-8.9ZM315.4,388.9h10.6l-5.5-32.1-5.1,32.1Z",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrandaWhite);
export default __webpack_public_path__ + "static/media/granda_white.379276320af2e883982d3e53ea39b083.svg";
export { ForwardRef as ReactComponent };